export default __webpack_public_path__ + "static/cd-stk-0cf40a330db653b526d5953de47f1984.jpg";